import { STORE_KEYS } from "@/shared/consts";

export const getDefaultCamera = (storeKey?: string): string => {
  let store = storeKey;

  if (!store) {
    const pathname = window.location.pathname;
    const storeKeyMatch = pathname.match(/\/stores\/([^/]+)/);
    store = storeKeyMatch?.[1];
  }

  switch (store) {
    case STORE_KEYS.GOKTURK_POD:
      return "148";
    case STORE_KEYS.ST2:
      return "1";
    case STORE_KEYS.ST1:
      return "101";
    default:
      return "1";
  }
};
